import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { DocumentAPI } from "../lib/api";
import DocumentPrintCard from "../components/DocumentPrintCard";
import { ShieldCheck, Loader2, Wand2 } from "lucide-react";

const VerifyDocumentPage = () => {
  const { vid } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const data = await DocumentAPI.verify(vid);
        setDoc(data);
      } catch (e) {
        setError("Verification ID not found, invalid, or this document is not publicly verifiable.");
      } finally {
        setLoading(false);
      }
    })();
  }, [vid]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 size={28} className="animate-spin text-[#d4a54b]" />
      </div>
    );
  }

  if (error || !doc) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6 text-center">
        <div>
          <h1 className="font-display text-[40px] mb-4">Verification failed</h1>
          <p className="text-white/55">{error}</p>
          <Link to="/" className="btn-primary mt-8 inline-flex">Back to dashboard</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="bg-[rgba(34,197,94,0.06)] border-b border-[rgba(34,197,94,0.25)] no-print">
        <div className="max-w-5xl mx-auto px-6 py-4 flex flex-wrap items-center gap-3 text-[13px]">
          <ShieldCheck size={16} className="text-[#22c55e]" />
          <span className="text-[#22c55e] font-semibold">Verified Authentic</span>
          <span className="text-white/55">
            This document was issued by <span className="text-white">{doc.issuer?.company}</span>.
            Verification ID <span className="font-mono text-[#d4a54b]">{doc.verification_id}</span>
          </span>
          <Link to="/" className="ml-auto text-[#d4a54b]/80 hover:text-[#d4a54b] flex items-center gap-1.5">
            <Wand2 size={13} /> WXZA Forge™
          </Link>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-12">
        <DocumentPrintCard document={doc} verificationUrl={`${window.location.origin}/verify-doc/${doc.verification_id}`} />
      </div>
    </div>
  );
};

export default VerifyDocumentPage;
